import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import {
    Button,
    Checkbox,
    CircularProgress,
    IconButton,
    MenuItem,
    Select, Slider, Tab,
    Tabs,
    TextField,
    Typography
} from "@mui/material";
import ApiCtrl, {MAIN_SERVER_URL, serverUrl} from "../svc/ApiCtrl";

import SmsFailedIcon from '@mui/icons-material/SmsFailed';
import DoneIcon from '@mui/icons-material/Done';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite';
import DeleteIcon from '@mui/icons-material/Delete';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import PauseIcon from '@mui/icons-material/Pause';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {ResponsiveHeatMapCanvas} from '@nivo/heatmap'
import {ResponsiveBarCanvas} from '@nivo/bar'
import LeftView from "./compo/LeftView";
import RightView from "./compo/RightView";
import DemoRightView from "./compo/DemoRightView";

export default function SingleView({path, setView}) {

    const [loading, setLoading] = React.useState(true);
    const [year, setYear] = React.useState(null);
    const [initYear, setInitYear] = React.useState(null);

    const [result, setResult] = React.useState(null);

    const [nday, setNDay] = React.useState(1);
    React.useEffect(() => {
        ApiCtrl.getResult(path, (result) => {
            setResult(result);
            setInitYear(result.periodMin)
            setYear(result.periodMin)
        })
    }, [])

    React.useEffect(() => {
        if(result && year && initYear){
            setLoading(false)
        }
    },[result,year,initYear])

    if (loading) {
        return (
            <Box sx={{width: "100vw", height: "95vh", display: "flex", p: 2}}>
                <CircularProgress/>
            </Box>
        )
    }

   if(true){
       return (
           <Box sx={{width: "100vw", height: "95vh", display: "flex", p: 2}}>
               <LeftView path={path} result={result} setView={setView} setYear={setYear} setNDay={setNDay}/>
               <Box sx={{width: 5}}/>
               <RightView path={path} result={result} setView={setView} year={year} initYear={initYear} nday={nday}/>

           </Box>
       )
   }
/*    return (
        <Box sx={{width: "100vw", height: "95vh", display: "flex", p: 2}}>
            <DemoRightView path={path} result={result} setView={setView} year={year} initYear={initYear} nday={nday}/>
        </Box>
    )*/
}

/*


 */
/*
<img src={getHeatmap(path)} sx={{height: 400}}/>
 */
